import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import CompanyLogo from '../../../../components/CompanyLogo';
import RatingStarsWidget from '../../../../components/RatingStarsWidget';
import RatingStarsWidgetEditable from '../../../../components/RatingStarsWidgetEditable';
import LinkBuilder from '../../../../helpers/link-builder';

const ReviewCard = props => {
  const {
    review,
    actions: { onRatingUpdateHandler, onBeforeRatingUpdateHandler },
    isLoggedIn,
  } = props;

  const { FirmName, FirmUrlAlias, Logo } = review.firm;

  const {
    position,
    Rating,
    posted,
    description,
    ResponseCount,
    HasCandidateRating,
    ReviewOwner,
    location,
  } = review;

  const logoStyles = {
    width: '135px',
    height: '135px',
    fontSize: '1rem',
    minWidth: '135px',
  };

  const count = ResponseCount ? (
    <>
      <span className="review-card__rating-widget-responses">
        {ResponseCount} response
        {ResponseCount !== 1 && 's'}
      </span>
    </>
  ) : null;

  const firmLink = LinkBuilder.getFirmLink(FirmUrlAlias);

  return (
    <div className="review-card">
      {isLoggedIn && (
        <div className="review-card__main">
          <h2 className="review-card__title">{position}</h2>

          <div className="review-card__inner">
            <div className="review-card__logo-wrapper">
              <CompanyLogo
                name={FirmName}
                logo={Logo}
                link={firmLink}
                styles={logoStyles}
              />
            </div>

            <div className="review-card__content">
              <a href={firmLink} className="review-card__company-name">
                {FirmName}
              </a>
              <p className="review-card__description">{description}</p>
              <span className="review-card__location">{location}</span>
            </div>
          </div>
        </div>
      )}

      <div
        className={
          isLoggedIn
            ? 'review-card__footer'
            : 'review-card__footer review-card__footer--guest'
        }
      >
        {!isLoggedIn && (
          <h2 className="review-card__title">
            {position} {description ? `(${description})` : ``}
          </h2>
        )}
        <div className="review-card__footer-inner">
          <div className="review-card__rating-widget">
            <span className="review-card__rating-widget-title">
              Review Rating
            </span>
            {!isLoggedIn || HasCandidateRating || ReviewOwner ? (
              <>
                <RatingStarsWidget value={Rating} size={16} />
                {count}
              </>
            ) : (
              <>
                <RatingStarsWidgetEditable
                  value={0}
                  size={16}
                  onChangeHandler={onRatingUpdateHandler}
                  onBeforeChangeHandler={onBeforeRatingUpdateHandler}
                />
                <span className="review-card__rating-widget-responses">
                  Rate this review
                </span>
              </>
            )}
          </div>
          <div className="review-card__date-posted">Posted {posted}</div>
        </div>
      </div>
    </div>
  );
};

ReviewCard.propTypes = {
  onBeforeRatingUpdateHandler: PropTypes.func,
  onRatingUpdateHandler: PropTypes.func,
};

export default ReviewCard;
